class CustomizerSelectionState {
  constructor(orchestrator) {
    this.orchestrator = orchestrator;

    this.selectedColorKey = 'rosa';
    this.selectedArtKey = null;
    this.selectedFontKey = orchestrator.FONTS[0]?.key || null;
    this.selectedTextColor = '#FFFFFF';
    this.selectedInitialTextColor = '#FFFFFF';
    this.selectedNameTextColor = '#FFFFFF';
    this.selectedTextLayout = 'fullname';
    this.customText = '';
    this.activeCategoryKey = 'todas';

    this.step = 1;
    this.reached = 1;
    this.style = null;
    this.method = null;
    // Laser fora de produção por enquanto: com data-laser-enabled="false" no
    // personalizador, Texto e Monograma usam Tinta sem a etapa de escolha.
    const customizerRoot = document.querySelector('.modal-customizer-my-bottle');
    this.laserEnabled = customizerRoot?.dataset.laserEnabled !== 'false';
    this.text = '';
    this.layout = 'fullname';
    this.font = this.selectedFontKey;
    this.inkColor = this.selectedTextColor;
    this.laserColor = 'prata';
    this.art = null;
    this.category = this.activeCategoryKey;
    this.accepted = false;
    this.zoom = 1;

    this.applyToken = 0;

    this.textureCache = new Map();
    this.imageCache = new Map();
    this.bodyBaseCache = new Map();
    this.loadedFonts = new Set();

    this.fontCarouselReady = false;
    this.textInputTimer = null;

    this.artsGridElement = null;
    this.artsGridWrapElement = null;
    this.artsFadeAnimationFrame = 0;
    this.artsHasMoreCached = null;

    this.sidebarSheetExpanded = false;
    this.sidebarSheetHeightPercent = orchestrator.SIDEBAR_SHEET_DEFAULT;
  }

  getSelectedColor() {
    const { COLORS } = this.orchestrator;
    return COLORS[this.selectedColorKey] || COLORS.rosa;
  }

  getSelectedArt() {
    if (!this.selectedArtKey) return null;
    return (
      this.orchestrator.ARTS.find(art => art.key === this.selectedArtKey) ||
      null
    );
  }

  getSelectedFont() {
    const { FONTS } = this.orchestrator;
    return (
      FONTS.find(font => font.key === this.selectedFontKey) || FONTS[0] || null
    );
  }

  getTrimmedCustomText() {
    return this.customText.trim();
  }

  setStyle(style) {
    if (this.style === style) return;
    this.style = style;
    this.method = null;
    if (style === 'textprint' || style === 'prints' || !this.laserEnabled) this.setMethod('ink');
    this.selectedArtKey = null;
    this.art = null;
    this.accepted = false;
    this.reached = 1;
    this.layout = style === 'mono' ? 'initials' : 'fullname';
    this.selectedTextLayout = this.layout;
    if (!this.requiresText()) {
      this.customText = '';
      this.text = '';
      const { textInput, contentTextCounter } = this.orchestrator.dom;
      if (textInput) textInput.value = '';
      if (contentTextCounter) contentTextCounter.textContent = '0/15';
    }
  }

  setMethod(method) {
    if (!['ink', 'laser'].includes(method)) return;
    if (this.method === method) return;
    this.method = method;
    this.accepted = false;
    this.reached = 1;
    this.selectedTextColor = method === 'laser'
      ? this.getLaserColorHex()
      : this.inkColor;
  }

  getLaserColorHex() {
    return this.laserColor === 'dourado' ? '#C9A24A' : '#C9CACD';
  }

  setInkColor(color) {
    this.inkColor = color;
    this.accepted = false;
    if (this.method !== 'laser') this.selectedTextColor = color;
  }

  setLaserColor(color) {
    if (!['prata', 'dourado'].includes(color)) return;
    this.laserColor = color;
    this.accepted = false;
    if (this.method === 'laser') this.selectedTextColor = this.getLaserColorHex();
  }

  requiresText() {
    return ['text', 'mono', 'textprint'].includes(this.style);
  }

  requiresArt() {
    return ['textprint', 'prints'].includes(this.style);
  }

  isStyleComplete() {
    if (!this.style) return false;
    if (this.style === 'text' || this.style === 'mono') return Boolean(this.method);
    return this.method === 'ink';
  }
}

window.CustomizerSelectionState = CustomizerSelectionState;
